export enum ClientStorageKey {
  CartToken = 'CartToken',
}

